<template>
    <div></div>
</template>
<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import { onMounted } from "vue";
import { defineComponent } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  props: {
    userId: {
      type: String,
      required: true,
    },
    userUrl: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    onMounted(async () => {
      fetch();
    });
    const { showToast } = useAppToast();
    const router = useRouter();

    const auth = useAuthStore();

    async function fetch() {
        // console.log("userId:", props.userId);
        // console.log("userUrl:", props.userUrl);
        // console.log("router:", router);
      let data = new FormData();
      data.append("id", props.userId);
      data.append("user_id", props.userUrl);
      await api.post(`/api/auth/authBylHash`, data).then(async (response) => {
        console.log("response:", response);
        if (response.data.msg == "no user") {
            showToast("Utilisateur non trouvé", "error");
        } else if (response.data.msg == "not authorized") {
            showToast("Non autorisé", "error");
            // router.push("/login");
        } else if (
          response.data.permissions &&
          response.data.permissions.length == 0
        ) {
          this.$swal.fire({
            icon: "error",
            title: "Aucun permissions affectées à ce compte",
            text: "Aucun permissions affectées à ce compte",
          });
        } else if (response.data.msg === "success") {
          localStorage.clear();

          const token = response.data.access_token;
          console.log("Login successful:", token);
          auth.clearAuth();
          auth.setToken(response.data.access_token); // Save token
          auth.setUser(response.data.user);
          auth.setPermissions(response.data.permissions);
        console.log("new auth:", response.data.access_token);

          showToast("Connexion réussie", "success");

          const resSts = await api.get("/api/auth/AllStatus");
          if (resSts.data) {
            localStorage.setItem("statutsList", JSON.stringify(resSts.data));
          }

        //   Redirect user after login
          router.push("/").then(() => {
            window.location.reload();
          });
        }else{
            //  showToast("Non autorisé", "error");
            // router.push("/login");
        }
      });
    }
    return {};
  },
});
</script>
